import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService, SharedserviceService } from 'src/app/services';
declare var $: any;

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  providers:[DatePipe]
})
export class OffersComponent implements OnInit {
  return_d_date: any;
  rreturn_d_date: any;
  travDetl:any;
  aval_seat: any;
  adult:number =1;
  child:number =0;
  travellerShow:boolean=false;
  infant:number =0;
  readMore:boolean=false;
  // showSelf:any= false;
  // showSelfBlock :any= false;
  // flightdetails:any=[];
  // flightBlockedDetails:any=[];
  data:any;keys:any;public page: number = 1;start = 0;msg:any
  travellerDetail: any;
  ccData:any;
  TotalCount:any;
  totalseatCount:any;
  totalpage:any;
  total: any=Number(JSON.parse(sessionStorage.getItem("search_form")).infant)+Number(JSON.parse(sessionStorage.getItem("search_form")).children)+Number(JSON.parse(sessionStorage.getItem("search_form")).adult);
  element:any;
  travellers: FormGroup;
  searchForm: FormGroup;
  offerList:any;
  DataReturn:any;
  combine:any=[];
  ownerData: any;
  flights_Dtl:any=[];
  flights_Block_Dtl:any=[];
  flights_showself:any=[];
  flights_showself_Block:any=[];
  booking_token:any;
  baseImageUrl:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedserviceService,
    public commonService:CommonService,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrManager,
    private fb: FormBuilder,
    public router: Router,
    private datePipe: DatePipe
  ) {
    this.ownerData= JSON.parse(sessionStorage.getItem("ownerData"));
    this.travDetl = JSON.parse(sessionStorage.getItem("travlerDetail"));
    this.flights_Dtl = JSON.parse(sessionStorage.getItem("flightdetails"));
    this.flights_Block_Dtl = JSON.parse(sessionStorage.getItem("flightBlockedDetails"));
    this.flights_showself = JSON.parse(sessionStorage.getItem("showself"));
    this.flights_showself_Block = JSON.parse(sessionStorage.getItem("showselfblock"));
    this.baseImageUrl = JSON.parse(sessionStorage.getItem("imagepath"));
    console.log("check images base url::::::::::",this.baseImageUrl);
    
   }

  ngOnInit() {
    console.log("this.total",this.total);
    
    // var fd; var fbd;
    //   fd=sessionStorage.getItem('flightdetails')
    //   fbd=sessionStorage.getItem('flightBlockedDetails')

    //   if(fd || fbd){
    //     fd.forEach(element => {
    //       this.flightdetails.push(element)
    //     });
    //     fbd.forEach(element => {
    //       this.flightBlockedDetails.push(element)
    //     });
    //     this.flightdetails=fd;
    //     this.flightBlockedDetails=fbd;
    //     this.showSelf=sessionStorage.getItem('showself')
    //     this.showSelfBlock=sessionStorage.getItem('showselfblock')
    //   }
    console.log("check travel detail:::::::::::::::",this.travDetl);
    
    this.offersListOneway();
    this.offersListReturn();

    this.searchForm = this.fb.group({
      adult: 1,
      child: 0,
      infant: 0
    })
    this.travellers = this.fb.group({
      adult: ['1'],
      child: ['0'],
      infant: ['0'],
    });
  }

  timeConvert(n) {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr  " + rminutes + " min";
  }
  
  offersListOneway(){
    this.ngxLoader.start();
    var sedData = {
      name :""
    }
    this.sharedService.post('v1/search_offer_flight/sectors_list_oneway',sedData).subscribe((res)=> {
    // this.sharedService.post('v1/search_offer_flight/sectors_fligth_type',sedData).subscribe((res)=> {
      if(res.replyCode == 'success'){
        (res.data).forEach(element => {
          this.combine.push(element)          
          this.combine.sort((a,b) => a.departure_city_name.localeCompare(b.departure_city_name));
        });
        this.data = res.data;
        this.ccData=res.data;
        console.log('sunil:::::::',this.ccData)
        // this.keys = Object.keys(this.data[0]);
        // this.TotalCount = res.totalRecords
        // this.totalpage=res.totalPage
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }

  bookflight(flight) {
    const self = this;
    // var formvalue = this.searchForm.value
    var formvalue = JSON.parse(sessionStorage.getItem("search_form"));
    // var travelDtl = JSON.parse(sessionStorage.getItem("travlerDetail"));
    console.log("travelDtl",(this.travDetl.adult+this.travDetl.child+this.travDetl.infant))
    
    this.aval_seat = flight.total_available_seats
    // var totalseat = (formvalue.adult+formvalue.children+formvalue.infant)
    this.totalseatCount = parseInt(this.travDetl.total);
    console.log("total seat count::::::::",this.totalseatCount);
    
    var totalseat = this.travDetl.total;
    console.log("hello",this.aval_seat,totalseat,formvalue)
    if (this.aval_seat >= totalseat) {
      var senddata = {
        flight_id: flight.flight_id,
        trip_type: formvalue.trip_type,
        departure_date: formvalue.departure_date,
        return_date: formvalue.return_date,
        adult: this.travDetl.adult,
        children: this.travDetl.child,
        infant: this.travDetl.infant,
        inventory_user_Type: "self",
        booking_token:JSON.parse(sessionStorage.getItem("booking_token_id")),
        inv_user:flight.inventory_user_Type

      }
      this.commonService.searchedflightdetail(senddata);
    } else {
      $('#confirmbooking').modal('show');
    }
  }

  durationdiff(dep_time, arr_time, dep_date, type) {
    var dep_hr = parseInt(dep_time.split(':')[0]);
    var arr_hr = parseInt(arr_time.split(':')[0]);
    if (arr_hr < dep_hr) {
      var nwdate;
      if (!dep_date) {
        nwdate = new Date();
      } else {
        nwdate = new Date(dep_date);
      }
      var newdate = nwdate.setDate(nwdate.getDate() + 1);
      if (type == 'oneway') {
        this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
      } else {
        this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }

    } else {
      this.return_d_date = dep_date;
      this.rreturn_d_date = dep_date;
    }
    //console.log("hr :: ",this.return_d_date); 
    var start_date = dep_date + " " + dep_time;
    var end_date = this.return_d_date + " " + arr_time;
    //console.log("start date : ",start_date,"end date :: ",end_date);
    return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));

  }

  getDataDiff(s_date, e_date) {
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours + " hrs " + ": " + minutes + " min";
    // return { day: days, hour: hours, minute: minutes, second: seconds };
  }


  offersListReturn(){
    this.ngxLoader.start();
    var sedData = {
      name :""
    }
    this.sharedService.post('v1/search_offer_flight/sectors_list_return',sedData).subscribe((res)=> {
      if(res.replyCode == 'success'){

        (res.data).forEach(element => {
          this.combine.push(element)          
          this.combine.sort((a,b) => a.departure_city_name.localeCompare(b.departure_city_name));
        });
        this.DataReturn = res.data
        console.log("ReturnData::::::",this.DataReturn);
        // this.ccData=res.data;
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }


  checkOffer(){
  // checkOffer(list,type){
    $('#totalpassengers').modal('show');
    // console.log("offerList Data",list);
    // this.offerList=list;
    // sessionStorage.setItem("offerDetail", JSON.stringify(this.offerList));
    // sessionStorage.setItem("offerType", JSON.stringify(type));
  }

  // traveller() {
  //   var adult = this.travellers.value.adult;
  //   var child = this.travellers.value.child;
  //   var infant = this.travellers.value.infant;

  //   if (adult != '' && child != '' && infant != '') {
  //     if (parseInt(adult) >= parseInt(infant)) {
  //       this.total = parseInt(adult) + parseInt(child) + parseInt(infant);

  //       this.searchForm.patchValue({
  //         adult: parseInt(adult),
  //         child: parseInt(child),
  //         infant: parseInt(infant)
  //       });

  //       $('#totalpassengers').modal('hide');
  //       this.searchForm.patchValue({ travellers: this.total });
  //       console.log("Total travlers:::::", this.searchForm.value);
  //       sessionStorage.setItem("travlerDetail", JSON.stringify(this.searchForm.value));
  //       // this.router.navigateByUrl("/offer-view");
  //     } else {
  //       alert('Please select infant less than adult');
  //     }

  //   } else {
  //     alert('All Field is required');
  //   }
  // }

  setAdult(val){
    this.adult=val;
  }  
  setChild(val){
    this.child=val;
  }  
  setInfant(val){
    this.infant=val;
  }  
  setTraveller(){
    this.travellerDetail = (this.adult + this.child + this.infant)
    // console.log("total value of traveller",this.travellerDetail);
    this.travellerShow = false;
  }
  
  // traveller() {
  //   var adult = this.travellers.value.adult;
  //   var child = this.travellers.value.child;
  //   var infant = this.travellers.value.infant;

  //   if (adult != '' && child != '' && infant != '') {
  //     if (parseInt(adult) >= parseInt(infant)) {
  //       this.total = parseInt(adult) + parseInt(child) + parseInt(infant);

  //       this.searchForm.patchValue({
  //         adult: parseInt(adult),
  //         child: parseInt(child),
  //         infant: parseInt(infant)
  //       });

  //       //console.log("formdata ::", this.searchForm);
  //       $('#totalpassengers').modal('hide');
  //       this.searchForm.patchValue({ travellers: this.total });
  //     } else {
  //       alert('Please select infant less than adult');
  //     }

  //   } else {
  //     alert('All Field is required');
  //   }
  // }

  traveller() {
    // var adult = this.travellers.value.adult;
    // var child = this.travellers.value.child;
    // var infant = this.travellers.value.infant;
    // if (this.adult != '' && this.child != '' && this.infant != '') {
  
      if (this.adult >= this.infant) {
        this.total = Number(this.adult) + Number(this.child) + Number(this.infant);
        var data={
          adult:Number(this.adult),
          child:Number(this.child),
          infant:Number(this.infant),
          total:this.total
        }
        this.travDetl = data;
        console.log("total :::::",this.total)
        $('#totalpassengers').modal('hide');
        this.searchForm.patchValue({ travellers: this.total });
        var requestdata=JSON.parse(sessionStorage.getItem("search_form"));
        requestdata.infant=data.infant
        requestdata.children=data.child
        requestdata.adult=data.adult
        sessionStorage.setItem("travlerDetail", JSON.stringify(data));
        sessionStorage.setItem("search_form", JSON.stringify(requestdata));

        // this.router.navigateByUrl("/offer-view");
        } else {
        alert('Please select infant less than adult');
      }    
    // }else{
    //   alert('Please select 1 adult');
    // }
  }

  contactSupport() {
    $('#offlineModle').modal('show');
  }

}
